import React from "react";
import style from "./c.module.css";
export const C1 = () => {
  return (
    <div className={style.c1}>
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/labs_desk/labs1.png"
        alt=""
      />
      <img
        src=" https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/labs_desk/labs2.png"
        alt=""
      />
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/labs_desk/labs3.png"
        alt=""
      />
      <img
        src=" https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/labs_desk/labs4.png"
        alt=""
      />
    </div>
  );
};

export const C2 = () => {
  return (
    <div className={style.c1}>
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/therapy_desk/therapy1.png"
        alt=""
      />
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/therapy_desk/therapy2.png"
        alt=""
      />
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/therapy_desk/therapy3.png"
        alt=""
      />
      <img
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_276,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/therapy_desk/therapy4.png"
        alt=""
      />
    </div>
  );
};

export const C3 = () => {
  return (
    <div className={style.c3bag}>
       <div>
       <img
        className={style.cimg}
        src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_442,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/wg_desktop/wg1.png"
        alt=""
      />
       </div>
      
            <div className={style.ccx}>
            <img
          src=" https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_535,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/wg_desktop/wg2.png"
          alt=""
        />
        <img
          src=" https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_597,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/wg_desktop/wg3.png"
          alt=""
        />
            </div>
             <div className={style.ccx}>
             <img
          src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_597,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/wg_desktop/wg4.png"
          alt=""
        />
        <img
          src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_458,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/wellness-widget/wg_desktop/wg5.png"
          alt=""
        />
             </div>
      </div>



     
  );
};
